import { render, staticRenderFns } from "./Ruler.vue?vue&type=template&id=06044fa9&"
import script from "./Ruler.vue?vue&type=script&lang=js&"
export * from "./Ruler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports